import { Navigate, useLocation } from "react-router-dom";
import api from "../../services/api";
import { buildAdminLoginPath, isOpsAuthRole } from "../../utils/routeAccess";

/**
 * Blocks /admin routes until an ADMIN/OPS session exists.
 * Guests and other roles are sent to username+password admin login.
 */
export default function AdminAuthGate({ children }) {
  const location = useLocation();
  const token = api.getToken?.();
  const authRole = api.getAuthRoleFromToken?.();

  if (token && isOpsAuthRole(authRole)) {
    return children;
  }

  const returnTo = `${location.pathname}${location.search}`;
  return (
    <Navigate
      to={buildAdminLoginPath(returnTo)}
      replace
      state={{ from: returnTo }}
    />
  );
}
